import { ScoreBarType } from '@models/aso/aso';
import { PieChartDataModel, LineChartDataModel } from '@models/highChartsModel';
import { CommonUtil } from '@utils/common/common';
import { BaseChart } from '@classes/options/chart/baseChart';
import * as _ from 'lodash';

const backgroundColor = ['#0bb783', '#ffa800', '#f64e60'];
const factors = [
  { name: 'mko', color: backgroundColor[0] },
  { name: 'cro', color: backgroundColor[1] },
  { name: 'rso', color: backgroundColor[2] },
];

export class CreateAsoOption {
  scoreBar(data): ScoreBarType[] {
    const _data = data
      ? factors.map((item, index) => ({
          title: item.name.toUpperCase(),
          data: data[item.name],
          background: item.color,
          index: index,
        }))
      : factors.map((item, index) => ({
          title: item.name.toUpperCase(),
          data: 0,
          background: item.color,
          index: index,
        }));
    return _data;
  }
  scorePie(data): PieChartDataModel {
    let totalValue = 0;
    let goalValue = 0;
    if (!!data) {
      const { mko, cro, rso, goal } = data;
      totalValue = mko + cro + rso;
      goalValue = goal;
    }
    return {
      title: {
        text: '',
      },
      legend: {
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
          },
          size: 150,
          innerSize: '50%',
          center: ['50%', '40%'],
          showInLegend: true,
        },
      },
      tooltip: new BaseChart().pieChartTooltipOption(),
      series: [
        {
          data: [
            {
              name: 'TOTAL',
              y: totalValue,
            },
            {
              name: 'GOAL',
              y: goalValue,
            },
          ],
        },
      ],
    };
  }

  dailyScore(data): LineChartDataModel {
    const _data = CommonUtil.getArrayByValidate(data);
    let series = [];
    let categories = [];
    if (_data.length > 0) {
      // 아래의 함수는 공통 함수로 뽑을 수 있음(추후 사용가능)
      categories = data.map((item) => item.baseDate);
      const seriesNameList = _.uniq(
        _.reduce(
          _data,
          (sum, cur) => {
            const keys = _.keys(cur).filter((item) => item !== 'baseDate');
            return sum.concat(keys);
          },
          []
        )
      );
      const tempSeries = seriesNameList.map((seriesName) => {
        return { name: seriesName, data: _data.map((item) => item[seriesName]) };
      });
      // 그래서 아래는 따로 color 를 추가처리함!
      series = tempSeries.map((item) => {
        switch (item.name) {
          case factors[0].name:
            return { ...item, color: factors[0].color };
          case factors[1].name:
            return { ...item, color: factors[1].color };
          case factors[2].name:
            return { ...item, color: factors[2].color };
          default:
            break;
        }
      });
    }

    return {
      series: series,
      xAxis: { categories },
      yAxis: new BaseChart().setBasicHighChartOption().yAxis,
    };
  }
}
